import filters from './loop-filters';
import categoriesNav from './categories-nav';

export default function init() {
	categoriesNav();
	filters();
}
